import { useId } from 'react';
import { cn } from '@/utils/cn';

interface CategoryCardGlowProps {
  className?: string;
}

const CARD_PATH
  = 'M0 16C0 7.16344 7.16344 0 16 0H162C170.837 0 178 7.16344 178 16V64C178 72.8366 170.837 80 162 80H16C7.16344 80 0 72.8366 0 64V16Z';

export function CategoryCardGlow({ className }: CategoryCardGlowProps) {
  const rawId = useId();
  const safeId = rawId.replace(/:/g, '');

  const paint0DefaultId = `category-card-paint0-default-${safeId}`;
  const paint1DefaultId = `category-card-paint1-default-${safeId}`;
  const paint0HoverId = `category-card-paint0-hover-${safeId}`;
  const paint1HoverId = `category-card-paint1-hover-${safeId}`;

  return (
    <div className={cn('group relative', className)}>
      <svg
        width="178"
        height="80"
        viewBox="0 0 178 80"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <path d={CARD_PATH} fill="#231333" />
        <g className="transition-opacity duration-300 group-hover:opacity-0">
          <path d={CARD_PATH} fill={`url(#${paint0DefaultId})`} />
          <path d={CARD_PATH} fill={`url(#${paint1DefaultId})`} />
        </g>
        <g className="opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <path d={CARD_PATH} fill={`url(#${paint0HoverId})`} />
          <path d={CARD_PATH} fill={`url(#${paint1HoverId})`} />
        </g>
        <defs>
          <radialGradient
            id={paint0DefaultId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(124 13.5) rotate(56.6336) scale(98.1835 76.4782)"
          >
            <stop stopColor="#4E256E" />
            <stop offset="1" stopColor="#4E256E" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id={paint1DefaultId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(25 80) rotate(-75.1414) scale(76.0427 172.535)"
          >
            <stop stopColor="#7C243D" />
            <stop offset="1" stopColor="#701F6F" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id={paint0HoverId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(124 13.5) rotate(56.6336) scale(98.1835 97.4094)"
          >
            <stop stopColor="#68269C" />
            <stop offset="1" stopColor="#6D2BA1" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id={paint1HoverId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(25 80) rotate(-73.8398) scale(91.6201 207.879)"
          >
            <stop stopColor="#8D2140" />
            <stop offset="1" stopColor="#8E248C" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}
